// Amplify configuration
// This will be populated with actual values after Terraform deployment

const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'us-east-2_XXXXXXXXX',
      userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || 'xxxxxxxxxxxxxxxxxxxxxxxxxx',
      region: process.env.REACT_APP_AWS_REGION || 'us-east-2',
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_COGNITO_DOMAIN || 'westbay-dev-auth.auth.us-east-2.amazoncognito.com',
          scopes: ['email', 'openid', 'profile'],
          redirectSignIn: [window.location.origin + '/callback'],
          redirectSignOut: [window.location.origin],
          responseType: 'code'
        }
      }
    }
  }
};

export default amplifyConfig;